import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose, mapProps } from 'recompose';
import classNames from 'classnames';

import requireProps from '../../../app/lib/requireProps';
import Button from '../../../app/components/Button';
import Routes from '../../Router/Routes';
import styles from './styles.css';
import TimereportsNotification from './components/TimereportsNotification';
import withMe from '../../containers/withMe';
import { useTranslation } from 'react-i18next';
import SharedFilesList from '../../../app/Resources/View/components/SharedFilesList';

function Home({ firstName, resource }) {
  const [isSharedFilesExpanded, setIsSharedFilesExpanded] = useState(false);

  const { t } = useTranslation();
  return (
    <div>
      <div className="row">
        <div className={classNames('col-md-12 text-center', styles.headerFirstname)}>
          <h1>{t("Välkommen")} {firstName}</h1>
        </div>
      </div>
      <div className="row">
        <div className={classNames('col-md-4 col-md-offset-4', styles.menu)}>
          <Button
            variant="primary"
            size="lg"
            icon="calendar-o"
            link={Routes.mySchedule()}
            stretch
            testID="mySchedule"
          >
            {t("Mitt schema")}
          </Button>
          <Button
            variant="primary"
            size="lg"
            icon="clock-o"
            link={Routes.timeReport()}
            testID="timeReport"
            stretch
          >
            <TimereportsNotification />
            {t("Tidrapportering")}
          </Button>
          <Button
            variant="primary"
            size="lg"
            icon="calendar"
            link={Routes.reportedTimes()}
            testID="reportedTimes"
            stretch
          >
            {t("Visa rapporterad tid")}
          </Button>
          <Button
            variant="primary"
            size="lg"
            icon="calendar-plus-o"
            link={Routes.availabilities()}
            testID="availabilities"
            stretch
          >
            {t("Tillgänglighet")}
          </Button>
          <Button
            variant="primary"
            size="lg"
            icon="map-marker"
            link={Routes.areaOfInterest()}
            stretch
          >
            {t("Intresseområde")}
          </Button>
          <Button
            variant="primary"
            size="lg"
            icon="user"
            link={Routes.me()}
            testID="me"
            stretch
          >
            {t("Mina uppgifter")}
          </Button>
          <Button
            variant="primary"
            size="lg"
            icon="file-o"
            stretch
            onClick={()=>{
              setIsSharedFilesExpanded(!isSharedFilesExpanded)
            }}
          >
            {t("Delade filer")}
          </Button>
          {isSharedFilesExpanded && 
            
            <SharedFilesList
              sharedFiles={resource.sharedFiles}
              isCollapsible={false}
              widgetInView="consultantDetails"
              currentUserId={resource.id}
              publicAccess={true}
            />
          
        }
        </div>
      </div>
    </div>
  );
}

Home.propTypes = {
  firstName: PropTypes.string.isRequired,
};

export default compose(
  withMe,
  requireProps(['resource'], true, true),
  mapProps(({ resource, staffingCompanyGroup }) => ({
    firstName: resource.get('firstName'),
    logo: staffingCompanyGroup ? staffingCompanyGroup.get('logo') : undefined,
    name: staffingCompanyGroup ? staffingCompanyGroup.get('name') : undefined,
    resource: resource,
  })),
)(Home);
